/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ModalConfirm } from "@nordcloud/gnui";
import { CloudResourceReportStatus } from "~/generated/graphql";
import { useDeleteCloudResourceReport } from "~/views/resources_v2/ResourceReports/hooks";

type Props = {
  reportId: string;
  reportName: string;
  reportStatus: CloudResourceReportStatus;
  isCancelModalOpen: boolean;
  close: () => void;
};

export function CancelModal({
  reportId,
  reportName,
  reportStatus,
  isCancelModalOpen,
  close,
}: Props) {
  const [deleteCloudResourceReport] = useDeleteCloudResourceReport({
    reportName: reportName,
    reportStatus: reportStatus,
  });

  const onCancel = () => {
    deleteCloudResourceReport({
      id: reportId,
    });
    close();
  };

  return (
    <ModalConfirm
      onClose={close}
      isOpen={isCancelModalOpen}
      confirm={onCancel}
      actionLabel="Confirm"
      data-testid="modal-cancel-report-generation"
      contentLabel={`Cancel Report Generation`}
    >
      {`Are you sure you want to cancel ${reportName} generation?`}
    </ModalConfirm>
  );
}
